'use strict';
import isString from 'lodash/isString';
import {getId, getLink} from '../../../core-utilities/domain/ReduxUtils';
import {ORGANIZATION_COLLECTION} from '../../../organizations/domain/config';
import {ASSET_PROJECT_COLLECTION} from '../../../projects/domain/AssetProjectDomain';
import {constructAssetProjectId, PROJECT_COLLECTION} from '../../../projects/domain/ProjectDomain';
import {COLLECTION as ASSET_TASK_COLLECTION} from '../../../tasks/domain/AssetTaskDomain';
import {ASSET_FILE_REQUIREMENT_CLASS_NAME, ASSET_FILE_REQUIREMENT_COLLECTION} from '../config';

export function AssetFileRequirementDomainProvider() {
  return {
    $get: [
      '$injector',
      '$ngRedux',
      'AbstractDomainClass',
      '$$AbstractFileRequirement',
      'restUtils',
      function (
        $injector,
        $ngRedux,
        AbstractDomainClass,
        $$AbstractFileRequirement,
        restUtils,
      ) {

        function AssetFileRequirementDomain(data) {
          AbstractDomainClass.call(this, AssetFileRequirementDomain, data);
        }

        $$AbstractFileRequirement.__inheritFrom(AssetFileRequirementDomain, ASSET_FILE_REQUIREMENT_CLASS_NAME, ASSET_FILE_REQUIREMENT_COLLECTION);

        AssetFileRequirementDomain.$constraints.addConstraints({
          assetTask: {type: 'Domain', domainClass: 'AssetTaskDomain'},
          requirement: {type: 'Domain', domainClass: 'FileRequirementDomain', nullable: true},

          task: {type: 'Domain', domainClass: 'TaskDomain', nullable: true}, /* Optional parent task id */
          ast: {type: 'string'} // Asset ID
        });

        // for fallback API methods
        AssetFileRequirementDomain.fallbackIdProperty = 'requirementId';
        AssetFileRequirementDomain.createFallbackMethod = 'asset-requirements/create';
        AssetFileRequirementDomain.updateFallbackMethod = 'asset-requirements/update';
        AssetFileRequirementDomain.updateStatusFallbackMethod = 'asset-requirements/status/update';

        // more methods go here;

        AssetFileRequirementDomain.createRequirementFromAssetRequirement = function (assetRequirement) {
          const FileRequirementDomain = $injector.get('FileRequirementDomain');
          const requirement = FileRequirementDomain.$factory.create();
          requirement.name = assetRequirement.name;
          requirement.description = assetRequirement.description;
          requirement.minimumFileCount = assetRequirement.minimumFileCount;
          requirement.maximumFileCount = assetRequirement.maximumFileCount;
          requirement.countIsEnforced = assetRequirement.countIsEnforced;
          requirement.prj = assetRequirement.prj;
          requirement.task = assetRequirement.assetTask ? assetRequirement.assetTask.task : null;

          return requirement;
        };

        AssetFileRequirementDomain.prototype.create = restUtils.createProto(AssetFileRequirementDomain, {
          getBody: (instance, options) => ({
            name: instance.name,
            description: instance.description,
            minimumFileCount: instance.minimumFileCount,
            maximumFileCount: instance.maximumFileCount,
            countIsEnforced: instance.countIsEnforced,
            assetTaskId: instance.assetTask && getId(instance.assetTask),
            taskId: instance.assetTask ? getLink(instance.assetTask, 'task').id : null,
            projectId: instance.assetTask && getLink(instance.assetTask, 'project').id,
            templateOptions: options || null,
          }),
        });

        AssetFileRequirementDomain.prototype.update = restUtils.updateProto(AssetFileRequirementDomain);

        AssetFileRequirementDomain.update = restUtils.updateStatic(ASSET_FILE_REQUIREMENT_COLLECTION);

        AssetFileRequirementDomain.$getPath = getPath;

        AssetFileRequirementDomain.prototype.$getPath = function () {
          return getPath(this);
        };

        AssetFileRequirementDomain.$getCollectionPath = getCollectionPath;
        AssetFileRequirementDomain.prototype.$getCollectionPath = getCollectionPath;

        AssetFileRequirementDomain.prototype.toString = function () {
          return this.requirement ? this.requirement.name : this.name;
        };

        AssetFileRequirementDomain.prototype.getDescription = function () {
          if (this.requirement) {
            return this.description ? this.description : this.requirement.description;
          } else {
            return this.description;
          }
        };

        return AssetFileRequirementDomain;
      }]
  };
}

export function getPath(instance) {
  if (isString(instance.org) && isString(instance.prj) && isString(instance.ast) && isString(getLink(instance, 'assetTask').id) && isString(getId(instance))) {
    return [
      instance.org,
      instance.prj,
      constructAssetProjectId(instance.prj, instance.ast),
      getLink(instance, 'assetTask').id,
      getId(instance),
    ].join('/');
  } else {
    console.warn('unable to fetch path for ', instance);
  }
}

export function getCollectionPath() {
  return [
    ORGANIZATION_COLLECTION,
    PROJECT_COLLECTION,
    ASSET_PROJECT_COLLECTION,
    ASSET_TASK_COLLECTION,
    ASSET_FILE_REQUIREMENT_COLLECTION,
  ].join('/');
}



// WEBPACK FOOTER //
// ./src/js/requirements/domain/files/AssetFileRequirementDomain.js